

<div class="agent-loader {{hideLoader ? 'hidden' : ''}} ">
  <i class="armx-scanner" style="color:white"></i>
</div>

<div class="recipt-scanner">
  <div class="recipt-scanner-header">
    <div class="row">
      <div class="col-md-1">
        <img src="/assets/icons/scanner.svg" style="max-width:50px;" />
      </div>
      <div class="col-md-11">
        <h4>{{ 'pages.createReceiptPage.oneReceipt.scanner.scanId' | translate}}</h4>
      </div>
    </div>
  </div>
  <div class="recipt-scanner-body">
    <div class="row">
      <div class="col-md-11 col-md-offset-1">
        <h5>{{ 'pages.createReceiptPage.oneReceipt.scanner.uploadOrScanConsigeeId' | translate}}</h5>
        <span [innerHtml]="validatorObject.ConsigneeId.message" style="color:#dc291e;font-size:12px"></span>
        <div class="scanner-box">
          <span>{{ 'pages.createReceiptPage.formatsAllow' | translate}}</span>
          <div class="pull-right">
            <!-- <select class="form-group" [(ngModel)]="scannerName">
              <option [ngValue]="-1">Select scanner</option>
              <option *ngFor="let scanner of scanners; i as index" [ngValue]="scanner" selected="{{i == 0}}">{{scanner}}</option>
            </select> -->
            <button class="btn btn-scanner" (click)="scanId()">
              <span class="armx-icon armx-barcode"></span> {{scanText}}
            </button>
            <button class="btn btn-scanner" (click)="showWebcamModal = true">
              <span class="armx-icon armx-camera"></span> {{ 'common.capture' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="dvamxscan"></div>
    <div class="row" *ngIf="isMobile()">
      <div class="col-md-8 col-md-offset-1">
        <div id="dwtcontrolContainer"></div>
      </div>
    </div>
    <!-- <div class="row" *ngIf="!isMobile() ">
      <div class="col-md-8 col-md-offset-1">
        <img class="img-responsive" style="width:25%" [src]="scannedImage1" />
      </div>
    </div> -->

    <div class="row">
      <div class="col-md-8 col-md-offset-1">
        <webcam-modal *ngIf="showWebcamModal"
                      (onImageCaptured)="handleWebcamCapturedImage($event)"
                      (onModalClosed)="showWebcamModal = false"></webcam-modal>
      </div>
    </div>

    <!--When you need to return the commecrial uplaod just you have to remove the below comment and send the shippmentId then everything will be fine-->
    <!--<div *ngIf="hasOutboundShipment">
      <div class="row">
        <div class="col-md-11 col-md-offset-1">
          <h5>Upload commercial invoice</h5>
          <div class="scanner-box">
            <span>  Allowed formats: JPG,GIF,PNG,TIFF or PDF</span>

            <div class="pull-right">
              <select class="form-group"
                      [(ngModel)]="scannerName2">
                <option [ngValue]="-1">Select scanner</option>
                <option *ngFor="let scanner of scanners; i as index" [ngValue]="scanner">{{scanner}}</option>
              </select>
              <button class="btn btn-scanner" (click)="scanCi()"><span class="armx-icon armx-barcode"></span>{{scanText2}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!isMobile() ">
        <div class="col-md-8 col-md-offset-1">
          <img class="img-responsive" style="width:25%" [src]="scannedImage2" />
        </div>
      </div>
      <div class="row" *ngIf="isMobile()">
        <div class="col-md-8 col-md-offset-1">
          <div id="dwtcontrolContainer"></div>
        </div>
      </div>
      <div class="row" *ngIf="isMobile()">
        <div class="col-md-8 col-md-offset-1">

          <webcam *ngIf="!isScaningCiLocked"
                  [height]="450"
                  [trigger]="triggerObservable" (imageCapture)="handleImage2($event)"
                  [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                  [videoOptions]="videoOptions"
                  [imageQuality]="1"
                  (cameraSwitched)="cameraWasSwitched($event)"
                  (initError)="handleInitError($event)">

          </webcam>
          <img *ngIf="webcamImageCommercialInvoice?.imageAsDataUrl !=null && isScaningCiLocked"
               class="img-responsive"
               src="{{webcamImageCommercialInvoice?.imageAsDataUrl}}" />
        </div>
      </div>
    </div>-->




    <div *ngIf="hasInboundShipment" class="row" style="margin-bottom: 2%">
      <div class="form-group">
        <div class="col-md-3 col-md-offset-1">
          <label class="control-label" style="font-weight:200">{{ 'common.name' | translate }}<span *ngIf="!validatorObject.Name.valid" style="color:#dc291e;font-size:18px">*</span></label>
          <input class="form-control" maxlength="200" [(ngModel)]="consigneeName" (blur)="checkName()" />
          <span [innerHtml]="validatorObject.Name.message" style="color:#dc291e;font-size:12px"></span>
        </div>
        <div class="char-count">
          {{ 'common.count' | translate : {char: getNameCount()} }}
        </div>
      </div>
    </div>

    <div *ngIf="hasInboundShipment" class="row" style="margin-bottom: 2%">
      <div class="form-group">
        <div class="col-md-3 col-md-offset-1">
          <label class="control-label" style="font-weight:200">{{ 'common.mobile' | translate }}<span *ngIf="!validatorObject.Mobile.valid && !isPhoneNumberOptional" style="color:#dc291e;font-size:18px">*</span></label>
          <input class="form-control" [disabled]="anyLocalShipmentFound" [(ngModel)]="phoneNumber" (blur)="resolvePhoneNumber()" />
          <span [innerHtml]="validatorObject.Mobile.message" style="color:#dc291e;font-size:12px"></span>
        </div>
      </div>
    </div>


    <div *ngIf="hasInboundShipment" class="row" style="margin-bottom: 2%">
      <div class="form-group">
        <div class="col-md-3 col-md-offset-1">
          <label class="control-label" style="font-weight:200">{{ 'common.email' | translate }}<span *ngIf="!validatorObject.Email.valid && !isEmailOptional" style="color:#dc291e;font-size:18px">*</span></label>
          <input type="email" class="form-control" [(ngModel)]="emailAddress" (blur)="checkEmail()" />
          <span [innerHtml]="validatorObject.Email.message" style="color:#dc291e;font-size:12px"></span>
        </div>
      </div>
    </div>

    <div *ngIf="hasInboundShipment" class="row" style="margin-bottom: 2%">
      <div class="form-group">
        <div class="col-md-3 col-md-offset-1">
          <label class="control-label" style="font-weight:200">{{ 'common.additionalInfo' | translate }}</label>
          <input class="form-control" [(ngModel)]="PodCustomerIdNumber" (blur)="checkPodCustomerIdNumber()" />
          <span [innerHtml]="validatorObject.PodCustomerIdNumber.message" style="color:#dc291e;font-size:12px"></span>
        </div>
      </div>
    </div>


    <div *ngIf="isTwoWayInboundAuthEnabled">
      <div *ngIf="hasInboundShipment" class="row" style="margin-bottom: 2%">
        <div class="form-group">
          <div class="col-md-3 col-md-offset-1">
            <label class="control-label" style="font-weight:200">Scanned AWBs</label>
            <input class="form-control"
                   [value]="scannedAWBs.join(', ')"
                   readonly />

            <button class="btn btn-success" color="secondary" (click)="clearScannedAWBs()">Clear</button>

            <div *ngIf="missingAWBs.length > 0" style="color: #dc291e; margin-top: 10px;">
              <strong>Missing AWBs:</strong> {{ missingAWBs.join(', ') }}
            </div>

            <div *ngIf="extraAWBs.length > 0" style="color: #e67e22; margin-top: 10px;">
              <strong>Unexpected (Extra) AWBs:</strong> {{ extraAWBs.join(', ') }}
            </div>
          </div>
        </div>
      </div>
    </div>






    <div *ngIf="hasInboundShipment">
      <!-- this is for e signatures -->
      <div *ngIf="!IsTopazIntegrated" class="row">
        <div div class="col-md-11 col-md-offset-1">
          <h5>Signature</h5>
          <div class="scanner-box" style="height:124px;">
            <canvas #signPadCanvas (touchstart)="startSignPadDrawing($event)" (touchmove)="movedFinger($event)"></canvas>
          </div>
          <button class="btn btn-success" color="secondary" (click)="saveSignPad()">Save</button>
          <button class="btn btn-danger" (click)="clearSignPad()">Clear</button>
        </div>
      </div>
      <!-- this is for Topaz signature pad -->
      <div *ngIf="IsTopazIntegrated" class="row">
        <div div class="col-md-11 col-md-offset-1">
          <h5>Signature</h5>
          <div class="scanner-box" style="height:124px;">
            <canvas #cnv id="cnv" name="cnv" width="500" height="100"></canvas>
          </div>
          <button class="btn" style="margin-right: 10px;" (click)="onSign()">Sign</button>
          <button class="btn btn-danger" style="margin-right: 10px;" (click)="onClear()">Clear</button>
          <button class="btn btn-success" color="secondary" (click)="onDone()">Done</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-11 col-md-offset-1 ">
      <div class="pull-right">
        <button class="btn btn-default" style="margin-left:20px;" (click)="previous()">{{ 'common.back' | translate }}</button>
        <button *ngIf="networkId == 1" class="btn btn-primary" style="margin-left:20px;" (click)="next()" [disabled]="disableNext">{{ 'pages.createReceiptPage.oneReceipt.scanner.paymentMethod' | translate}}</button>
        <button *ngIf="networkId != 1" class="btn btn-primary" style="margin-left:20px;" (click)="next()" [disabled]="disableNext">{{ 'pages.createReceiptPage.oneReceipt.scanner.next' | translate}}</button>
      </div>
    </div>
  </div>
</div>
